import { render, staticRenderFns } from "./EformInputBox.vue?vue&type=template&id=fb77203e&"
import script from "./EformInputBox.vue?vue&type=script&lang=js&"
export * from "./EformInputBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports